import { CancelToken, Method } from 'axios';

/** 请求状态码 */
export const API_RESPONSE_SUCCESS_CODE = 0 as const;

export enum ApiResponseErrorCodeEnum {
  /** 系统异常，未知的异常都返回-1 */
  Error = -1,
  RepeatSubscribe = 70001,
}
/** 请求异常 */
export type ApiResponseError<T = unknown> = {
  /** 错误码 */
  code: ApiResponseErrorCodeEnum;
  /** 错误原因，后端会直接返回 */
  msg: string;
  /** 请求数据 */
  data: T;
  /** 错误数据，看业务场景下是否有 */
  errorData?: T;
  /** requestId，方便排查问题 */
  requestId?: string;
};

/** 请求成功，data值可能为空 */
export type ApiResponseSuccess<T = undefined> = {
  /** 错误码 */
  code: typeof API_RESPONSE_SUCCESS_CODE | ApiResponseErrorCodeEnum;
  /** 请求数据 */
  data?: T;
  /** requestId，方便排查问题 */
  requestId?: string;
};

/** api返回类型 */
export type ApiResponse<T, U = unknown> = ApiResponseSuccess<T> | ApiResponseError<U>;

export type HttpRequestParams<T = unknown> = {
  /** 接口路径 */
  url: string;
  method?: Method;
  headers?: Record<string, string>;
  /** post 请求体数据 */
  data?: T;
  /** 拼接在url后的参数 或 URLSearchParams 对象*/
  params?: Record<string, string | number> | URLSearchParams;
  /** 自定义responseType , html的返回类型是请求于我们后端服务器返回html表单使用的 */
  responseType?: ResponseType | 'html';
  /** 是否移除分销码，否则默认params会带上分销码 */
  removeInsrc?: boolean;
  /** header是否带上userToken */
  instaToken?: boolean;
  /** 上传进度回调 - loaded已经上传的进度，total总进度 */
  onUploadProgress?: (progress: { loaded: number; total: number }) => void;
  /** 用于取消请求的标识id 使用new axios.CancelToken生成 */
  cancelToken?: CancelToken;
  /** 复杂参数使用：可以自定义序列化行为，使用qs.stringify处理params，特殊字符可以被正确编码成URL格式*/
  serializer?: boolean;
  /** 外部传入语言作为params */
  X_Language?: X_Language;
  /** 外部传入国家码作为params */
  X_Country_Code?: TCountryCode;
};
